var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleLinkCard',{attrs:{"tag":_vm.tag,"href":_vm.href,"target":_vm.target,"text":_vm.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }